module.exports = __webpack_public_path__ + "img/strideux-logo.3bd428d6.svg";